import React from 'react';
import { PopperDropdownManager, PopperDropdownToggle, } from '../../PopperDropdownLayout';
import StandardDropdownMenu from '../StandardDropdown/StandardDropdownMenu';
import { useDropdownItems } from '../../hooks/useDropdownItems';
import IconButton from '../../../Button/IconButton';
export var IconButtonWithContextMenu = function (_a) {
    var className = _a.className, items = _a.items, children = _a.children, contextMenuClassName = _a.contextMenuClassName, tooltipText = _a.tooltipText;
    var filteredItems = useDropdownItems(items).filteredItems;
    return (React.createElement(PopperDropdownManager, null,
        React.createElement(PopperDropdownToggle, { className: className },
            React.createElement(IconButton, { "aria-haspopup": true, tooltipText: tooltipText }, children)),
        React.createElement(StandardDropdownMenu, { menuScrollable: true, menuClassName: contextMenuClassName, items: filteredItems, menuAlignment: 'right', usePortal: true })));
};
IconButtonWithContextMenu.displayName = 'IconButtonWithContextMenu';
export default IconButtonWithContextMenu;
//# sourceMappingURL=IconButtonWithContextMenu.js.map